import React, { ReactNode } from 'react'

import { useTheme } from '@mui/material'

import Box from 'components_new/atoms/Box'

interface GenericWidgetBaseProps {
  children: ReactNode
  disableBorder?: boolean
  disablePadding?: boolean
  editMode: boolean
  hasHeader?: boolean
  scaleFactor: number
}

const GenericWidgetBase = (props: GenericWidgetBaseProps) => {
  const {
    children,
    disableBorder,
    disablePadding,
    editMode,
    hasHeader,
    scaleFactor
  } = props

  const theme = useTheme()

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          height: '100%',
          minWidth: 0,
          width: '100%',
          // widget-menu exist in another component
          '& .widget-menu': {
            display: editMode ? 'block' : 'none'
          },
          '&:hover': {
            '& .widget-menu': {
              display: 'block'
            },
            '& .widget-paper': {
              borderColor: editMode ? theme.palette.action.focus : undefined
            }
          }
        }}
      >
        <Box
          className="widget-paper"
          sx={{
            bgcolor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minWidth: 0,
            p: disablePadding ? undefined : 2 * scaleFactor,
            pt: hasHeader ? 1 : undefined,
            position: 'relative',
            width: '100%',
            ...(disableBorder
              ? null
              : {
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1
                })
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  )
}

export default GenericWidgetBase
